import { axios } from '../../utils/apiUtils';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getAxiosConfig } from '../../utils/apiUtils';
import Season from '../../components/season';
import commonStyles from '../../common';
import { Col, Container, ListGroup, Modal, Row } from 'react-bootstrap';

import seasonIcon from '../../assets/images/stations.svg';
import { getOneTimeEvents, isAllowedToPlayVideo, setOneTimeEvents, getLoggedInUser, updateUser } from '../../utils/authUtils';

import { Redirect } from 'react-router';

import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';
import { Navigation, Scrollbar, A11y, Zoom } from 'swiper';
import 'swiper/swiper.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'swiper/modules/navigation/navigation.min.css';
import { useSwiper } from 'swiper/react/swiper-react';

const styles = {
  welcomeBar: {
    marginLeft: '15px',
    marginRight: '15px',
  },
  header: {
    backgroundColor: '#f0f2f5',
    marginTop: '32px',
    marginBottom: '32px',
  },
  title: {
    ...commonStyles.chungungoH1,
    color: 'darkOrange',
  },
  container: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  row: {
    marginLeft: 0,
    marginRight: 0,
  }
};

const Seasons = () => {
  const { t, i18n } = useTranslation();
  const [seasons, setSeasons] = useState([]);
  const [showWelcome, setShowWelcome] = useState(!getOneTimeEvents().welcome && !isAllowedToPlayVideo());
  const [goToSubscription, setGoToSubscription] = useState(false);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [experiences, setExperiences] = useState([]);
  const [monthly, setMonthly] = useState([]);
  const [newestSeasons, setNewestSeasons] = useState([]);
  const [keepWatching, setKeepWatching] = useState([]); 
  const [visitAgain, setVisitAgain] = useState([]);
  
  const currentUser = getLoggedInUser();
  const [user, setUser] = useState(); 
  const swiper = useSwiper();

  const refreshUserData = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/users/${getLoggedInUser().user.id}`,
      getAxiosConfig(),
    )
      .then((userResponse) => {
        setUser(userResponse.data);
        updateUser({
          user: userResponse.data
        });
        refreshKeepWatchingList();
        refreshVisitAgainList();
      })
      .catch((userError) => {
        console.debug(userError);
      });
  };

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  });

  const handleWelcomeClose = () => {
    setOneTimeEvents({
      welcome: true,
    })
    setShowWelcome();
  };

  const handleSubscribe = () => {
    setOneTimeEvents({
      welcome: true,
    })
    setGoToSubscription(true);
  };

  const refreshSeasonsList = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/seasons/complete_list`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((seasonsResponse) => {
        setSeasons(seasonsResponse.data);
      })
      .catch(console.error);
  };

    // get most watched seasons
    const refreshMonthlyData = () => {
      axios.get(
        `${process.env.REACT_APP_API_URL}/analytics/completed_experiences`,
        getAxiosConfig(),
        ).then((monthlyResponse) => {
          setMonthly(monthlyResponse.data.slice(0, 8));
        })
        .catch((userError) => {
          console.debug(userError);
        });
    };
  
    // get new seasons
    const refreshNewestSeasonsList = () => {
      axios.get(
        `${process.env.REACT_APP_API_URL}/seasons/newest_seasons_list`,
        {
          ...getAxiosConfig(),
        },
      )
        .then((newestSeasonsResponse) => {
          setNewestSeasons(newestSeasonsResponse.data.slice(0, 8));
        })
        .catch(console.error);
    };

    // get keep watching seasons
    const refreshKeepWatchingList = () => {
      axios.get(
        `${process.env.REACT_APP_API_URL}/seasons/${getLoggedInUser().user.id}/keep_watching`,
        {
          ...getAxiosConfig(),
        },
      )
        .then((keepWatchingResponse) => {
          setKeepWatching(keepWatchingResponse.data);
        })
        .catch(console.error);
    };

    // get visit again seasons
    const refreshVisitAgainList = () => {
      axios.get(
        `${process.env.REACT_APP_API_URL}/seasons/${getLoggedInUser().user.id}/visit_again`,
        {
          ...getAxiosConfig(),
        },
      )
        .then((visitAgainResponse) => {
          setVisitAgain(visitAgainResponse.data);
        })
        .catch(console.error);
    };

  useEffect(
    () => {
      refreshSeasonsList();
      refreshExperiencesList();

      refreshUserData();
      refreshMonthlyData();
      refreshNewestSeasonsList();
    },
    []
  );

  //console.log(user.id);

  if (goToSubscription) {
    return <Redirect to="/account/subscribe/confirm" push/>
  }

  const refreshExperiencesList = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/experiences/all`,
      {
        ...getAxiosConfig(),
      },
    )
      .then((experiencesResponse) => {
        setExperiences(experiencesResponse.data);
      })
      .catch(console.error);
  };


  return (
    <section className="pt-4 mb-5">
      <Modal
        show={showWelcome}
        onHide={evt => handleWelcomeClose()}
      >
        <div className="modal-content">
          <div className="modal-body">
            <h5 className="modal-title mb-3" style={{ color: '#692700' }}>{t('seasons.welcomemodal.title')}</h5>
            <p style={{ whiteSpace: "pre-line" }}>
              {t('seasons.welcomemodal.message')}
            </p>
            <p>
              <strong>¡Hagamos Cosas Juntos!</strong>
            </p>
          </div>
          <div className="modal-footer">
          <button type="button" className="btn btn-link" onClick={evt => handleWelcomeClose(false)}>
            {t('seasons.welcomemodal.close')}
          </button>
          <button type="button" className="btn btn-outline-success" onClick={evt => handleSubscribe()}>
            {t('seasons.welcomemodal.subscribe')}
          </button>
          </div>
        </div>
      </Modal>
      <div className="container"
        style={styles.container}
      >
        <div className="row pt-5"
          style={styles.row}
        >
          <div className="col-12 align-self-start caj-Titulo-Principal pt-3">
            <span 
              className="icon-headline-1 station-icon"
              style={{
                backgroundImage: `url(${seasonIcon})`
              }}
            ></span>
            <h1 className="headline-1">{t('seasons.title')}</h1>
          </div>
          {/* 
            loop={true}
            loopFillGroupWithBlank={true}
            when using loop, initial slide should be same number as slides per view
          */}
          <div className="col-12">
            <a className="carouselTitle" href="/featured">Estaciones destacadas:<span className="explore-span"> Explorar todas</span></a>
          </div>
          <Swiper
            className="seasonsSwiper"
            spaceBetween={18}
            slidesPerView={4}
            initialSlide={0}
            slidesPerGroup={2}
            modules={[Navigation, A11y, Pagination]}
            pagination={{ clickable: true }}
            navigation
            observer= {true}
            observeParents= {true}
            parallax= {true}
            simulateTouch={true}
            onSlideChange={() => console.log('slide change')}
            onSwiper={(swiper) => console.log(swiper)}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              540: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              960: {
                slidesperView: 3,
              },
              1200: {
                slidesperView: 4,
              },
            }}
          >
          {seasons.map((season) => (
            season.isFeatured && <SwiperSlide key={season.name}><Season season={season} /></SwiperSlide>
          ))}
          </Swiper>
          
          {(newestSeasons && newestSeasons.length > 0 ) &&
            <><div className="col-12">
              <a className="carouselTitle" href="/new">Recién actualizadas:<span className="explore-span"> Explorar todas</span></a>
              </div><Swiper
              className="seasonsSwiper"
              spaceBetween={18}
              slidesPerView={4}
              initialSlide={0}
              slidesPerGroup={2}
              modules={[Navigation, A11y, Pagination]}
              pagination={{ clickable: true }}
              navigation
              observer={true}
              observeParents={true}
              parallax={true}
              simulateTouch={true}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                540: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                960: {
                  slidesperView: 3,
                },
              }}
            >
                {newestSeasons.map((season) => (
                  <SwiperSlide key={season.name}><Season season={season} /></SwiperSlide>
                ))}
              </Swiper></>
            }

          { (keepWatching && keepWatching.length > 0 ) &&
          <><div className="col-12">
              <a className="carouselTitle" href="/keepwatching">Continuar viendo:<span className="explore-span"> Explorar todas</span></a>
            </div>
            <Swiper
              className="seasonsSwiper"
              spaceBetween={18}
              slidesPerView={4}
              initialSlide={0}
              slidesPerGroup={2}
              modules={[Navigation, A11y, Pagination]}
              pagination={{ clickable: true }}
              navigation
              observer={true}
              observeParents={true}
              parallax={true}
              simulateTouch={true}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                540: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                960: {
                  slidesperView: 3,
                },
              }}
            >
                {keepWatching.map((season) => (
                  <SwiperSlide key={season.name}><Season season={season} /></SwiperSlide>
                ))}
              </Swiper></>
          }
          {(monthly && monthly.length > 0 ) &&
          <><div className="col-12">
              <a className="carouselTitle" href="/mostwatched">Estaciones más vistas:<span className="explore-span"> Explorar todas</span></a>
              </div>
              <Swiper
              className="seasonsSwiper"
              spaceBetween={18}
              slidesPerView={4}
              initialSlide={0}
              slidesPerGroup={2}
              modules={[Navigation, A11y, Pagination]}
              pagination={{ clickable: true }}
              navigation
              observer={true}
              observeParents={true}
              parallax={true}
              simulateTouch={true}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                540: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                960: {
                  slidesperView: 3,
                },
              }}
            >
                {monthly.map((season) => (
                  <SwiperSlide key={season.name}><Season season={season} /></SwiperSlide>
                ))}
              </Swiper></>
          }

          { (visitAgain && visitAgain.length > 0 ) &&
          <><div className="col-12">
              <a className="carouselTitle" href="/visitagain">Volver a visitar:<span className="explore-span"> Explorar todas</span></a>
            </div>
            <Swiper
              className="seasonsSwiper"
              spaceBetween={18}
              slidesPerView={4}
              initialSlide={0}
              slidesPerGroup={2}
              modules={[Navigation, A11y, Pagination]}
              pagination={{ clickable: true }}
              navigation
              observer={true}
              observeParents={true}
              parallax={true}
              simulateTouch={true}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                540: {
                  slidesPerView: 2,
                  spaceBetween: 15,
                },
                960: {
                  slidesperView: 3,
                },
              }}
            >
                {visitAgain.map((season) => (
                  <SwiperSlide key={season.name}><Season season={season} /></SwiperSlide>
                ))}
              </Swiper></>
          }
          
          <div className="col-12">
            <a className="carouselTitle" href="/all">Todas las Estaciones:<span className="explore-span"> Explorar todas</span></a>
          </div>
          <Swiper
            className="seasonsSwiper"
            spaceBetween={18}
            slidesPerView={4}
            initialSlide={0}
            slidesPerGroup={2}
            modules={[Navigation, A11y, Pagination]}
            pagination={{ clickable: true }}
            navigation
            observer= {true}
            observeParents= {true}
            parallax= {true}
            simulateTouch={true}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              540: {
                slidesPerView: 2,
                spaceBetween: 15,
              },
              960: {
                slidesperView: 3,
              },
            }}
          >
          {seasons.map((season) => (
            <SwiperSlide key={season.name}><Season season={season} /></SwiperSlide>
          ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Seasons;
